import { getUserConfiguration, getAccountScopeUserSettings } from 'owa-session-store';
import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';

/*
 * Get the current user address in obscured format: {mailboxGuid}@{tenantDomain}
 */
export default function getObscuredCurrentUserAddress(): string {
    const sessionSettings = getUserConfiguration().SessionSettings;
    const mailboxGuid = getAccountScopeUserSettings(
        /* eslint-disable-next-line owa-custom-rules/no-reflow-methods  -- (https://aka.ms/OWALintWiki)
         * Reflow related methods should not be used, see https://aka.ms/multiaccountlinter
         *	> Do Not Use Reflow: The getSelectedAccountMailboxInfo function should not be used for Respond multi-account support. */
        getSelectedAccountMailboxInfo()
    )?.SessionSettings?.MailboxGuid?.replace(/\-/g, '');

    // The Obscured Email address to be shared with attendee has format: {mailboxGuid}@{tenantDomain}
    // ex: 111111110000aaaabbbb444444444444@contoso.com
    return mailboxGuid + '@' + sessionSettings?.TenantDomain;
}
